import moment from 'moment';
import { paymentPeriods, paymentSources } from '../constants';

// The $1 Pro trial. The server decides who may take it (workspace.trialEligible) and checks again when
// checkout opens, so this only decides where the offer shows and what it says.
export const PRO_TRIAL_DAYS = 7;
export const PRO_TRIAL_PRICE = 1;
export const PRO_MONTHLY_PRICE = 29;

// What a trial unlocks, in the words the offer uses wherever it appears
export const PRO_VALUE = [
  { title: 'Every widget type', detail: 'Grid, Marquee, Multi Carousel, List and Toast' },
  { title: 'Unlimited testimonials', detail: 'No 15-testimonial cap on imports, forms or widgets' },
  { title: 'A Wall of Love without limits', detail: 'Every testimonial, no Shapo branding, indexed by Google' },
  { title: 'No Shapo branding', detail: 'On widgets, forms, Wall of Love and Review Booster' },
  { title: 'Automatic review imports', detail: 'New reviews from 30+ platforms arrive on their own' },
  { title: 'Email campaigns', detail: '500 testimonial requests a month' },
  { title: 'Your team', detail: 'Invite up to 5 members' },
];

// the bar across the top of the dashboard offers the trial for the first week after signup
const TRIAL_BAR_DAYS = 7;

export function isTrialBarShown(workspace, createdAt) {
  if(!createdAt || !isTrialOffered(workspace)) {
    return false;
  }
  return moment().diff(moment(createdAt), 'days', true) < TRIAL_BAR_DAYS;
}

export function isTrialOffered(workspace) {
  const paymentPlatform = (workspace && workspace.paymentPlatform) || paymentSources.STRIPE;
  return !!(workspace && workspace.trialEligible && paymentPlatform === paymentSources.STRIPE);
}

// the date a trial started today converts to the monthly plan
export function getTrialEndDate() {
  return moment().add(PRO_TRIAL_DAYS, 'days').format('MMM D');
}

// a discount code applies from the first monthly payment, the server attaches it after the $1 fee
export function getTrialCheckoutApi(workspaceId, promoCode) {
  const code = promoCode && promoCode.trim();
  return `${process.env.NEXT_PUBLIC_API_BASE}/workspaces/${workspaceId}/billing/checkout-redirect`
    + `?platform=${paymentSources.STRIPE}&period=${paymentPeriods.MONTHLY}`
    + `&plan=${process.env.NEXT_PUBLIC_PRO_MONTHLY}&trial=true${code ? `&promo=${encodeURIComponent(code)}` : ''}`;
}
